<template>
    
    <div class="card-board-container">

       <div class="card-board-main"> 

            <div class="card-board-top">
                请抽取一张图 
            </div>

            <div class="card-board-line">

                <img :src="images.line1" id="cb-line-1" />

                <img :src="images.line2" id="cb-line-2" />
            </div>

            <div class="card-board-box">
                
                <div
                    v-for="image in imageArr"
                    :key="image.groupId"
                    :id="image.groupId"
                >
                    
                    <img :src="icons.clipper" class="cbb-clipper" />

                    <img :src="images.photoBase" class="cbb-card" />

                    <img 
                        :src="image.front.src" 
                        :id="image.front.id" 
                        class="cbb-front cbb-image"
                        @click="flipImage(image)"
                    />

                    <img 
                        :src="image.back.src" 
                        :id="image.back.id" 
                        style="display: none"
                        class="cbb-back cbb-image"
                        @click="selectImage(image)"
                    />
                </div>
            </div>
       </div>
    </div>
</template>

<script>

    import { 
        reactive, 
        toRefs, 
        getCurrentInstance,
        onMounted 
    } from "vue";

    import clipperIcon from "@/assets/card/clipper.png";
    import photoBaseImage from "@/assets/card/photo-base.png";
    import line1Image from "@/assets/card/line-1.png";
    import line2Image from "@/assets/card/line-2.png";

    export default {
        name: "CardBoard",
        props: {
            imageArr: {
                type: Array
            },
            imageMap: {
                type: Object
            }
        },
        setup(props) {

            const _this = getCurrentInstance().appContext.config.globalProperties;

            // const { ANIMATE, STYLE, EVENT } = _this.$constants;
            const { STYLE, EVENT } = _this.$constants;

            const state = reactive({
                icons: {
                    clipper: clipperIcon
                },
                images: {
                    line1: line1Image,
                    line2: line2Image,
                    photoBase: photoBaseImage
                }
            });

            onMounted(() => {

                const { imageArr, imageMap } = props;

                if (!imageMap) {
                    return;
                }

                imageArr.forEach(image => {

                    const { groupId } = image;

                    if (imageMap[groupId]) {
                        flipImage(image);
                    }
                });
            });

            const retrieveImageElement = (image) => {

                const { front, back } = image;

                const frontId = `#${front.id}`;
                const backId = `#${back.id}`;

                const frontImageElement = document.querySelector(frontId);
                const backImageElement = document.querySelector(backId);

                return {
                    frontImageElement,
                    backImageElement
                };
            };

            const flipImage = (image) => {

                const { frontImageElement, backImageElement } = retrieveImageElement(image);

                frontImageElement.style.display = STYLE.NONE;
                // frontImageElement.classList.add(ANIMATE.ANIMATED, ANIMATE.FADE_OUT);

                backImageElement.style.display = STYLE.EMPTY_STRING;
                // backImageElement.classList.add(ANIMATE.ANIMATED, ANIMATE.FLIP_IN_Y);

                selectImage(image);
            };

            const selectImage = (image) => {

                _this.$bus.$emit(EVENT.IMAGE_READY, {
                    image
                });
            }

            return {
                ...toRefs(state),
                flipImage,
                selectImage
            };
        }
    }
</script>

<style lang="scss" scoped>

    #cb-line-1 {
        width: 100%;
        height: auto;
    }

    #cb-line-2 {
        width: 100%;
        height: auto;
    }

    @media screen and (max-height: 800px) {
        
        .card-board-container {

            .card-board-main {

                border: 5px solid #8AB8FF;
                background-color: #E1EAFC;
                border-radius: 15px;
                position: fixed;
                top: 25%;
                left: 4%;
                right: 4%;
                width: 92%;
                height: 64%;

                .card-board-top {
                    position: fixed;
                    left: calc((100% - 64%) / 2);
                    top: 23.6%;
                    width: 64%;
                    height: 6.5%;
                    background: linear-gradient(0deg, #3993FF, #6DB4FF);
                    box-shadow: 0px 3px 3px 0px rgba(40, 42, 45, 0.21), 0px 4px 8px 0px rgba(255, 255, 255, 0.36);
                    border-radius: 10px;
                    font-weight: 400;
                    color: #FEFEFF;
                    line-height: 5px;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    font-size: 1.4rem;
                    letter-spacing: 2px;
                }

                .card-board-box {

                    .cbb-clipper {
                        height: 30px;
                        width: auto;
                    }

                    .cbb-card {
                        width: 6rem;
                        height: 6.7rem;   
                    }

                    .cbb-image {
                        width: 4.8rem;
                        height: auto;
                    }

                    #image-1 {

                        .cbb-clipper {
                            position: fixed;
                            left: 24%;
                            top: 31.8%;
                            z-index: 100;
                        }

                        .cbb-card {
                            position: fixed;
                            left: 13%;
                            top: 35.6%;
                        }

                        .cbb-image {
                            position: fixed;
                            left: 15.6%;
                            top: 36.4%;
                        }
                    }

                    #image-2 {

                        .cbb-clipper {
                            position: fixed;
                            right: 26%;
                            top: 32.7%;
                            z-index: 100;
                        }

                        .cbb-card {
                            position: fixed;
                            right: 15%;
                            top: 36.5%;
                        }

                        .cbb-image {
                            position: fixed;
                            right: 17.3%;
                            top: 37.3%;
                        }
                    }

                    #image-3 {

                        .cbb-clipper {
                            position: fixed;
                            left: 16%;
                            top: 53.8%;
                            z-index: 100;
                        }

                        .cbb-card {
                            position: fixed;
                            left: 5%;
                            top: 57.5%;
                        }

                        .cbb-image {
                            position: fixed;
                            left: 7.6%;
                            top: 58.4%;
                        }
                    }

                    #image-4 {

                        .cbb-clipper {
                            position: fixed;
                            left: 47%;
                            top: 55.9%;
                            z-index: 100;
                        }

                        .cbb-card {
                            position: fixed;
                            left: 36%;
                            top: 59.8%;
                        }

                        .cbb-image {
                            position: fixed;
                            left: 38.7%;
                            top: 60.6%;
                        }
                    }

                    #image-5 {

                        .cbb-clipper {
                            position: fixed;
                            right: 16%;
                            top: 53.8%;
                            z-index: 100;
                        }

                        .cbb-card {
                            position: fixed;
                            right: 5.6%;
                            top: 57.7%;
                        }

                        .cbb-image {
                            position: fixed;
                            right: 8%;
                            top: 58.5%;
                        }
                    }
                }
            }

            #cb-line-1 {
                position: fixed;
                left: 0;
                top: 30%;
            }

            #cb-line-2 {
                position: fixed;
                left: 0;
                top: 53%;
            }
        }
    }

    @media screen and (min-height: 800px) {
        
        .card-board-container {

            .card-board-main {

                border: 5px solid #8AB8FF;
                background-color: #E1EAFC;
                border-radius: 15px;
                position: fixed;
                top: 21.1%;
                left: 2%;
                right: 2%;
                width: 96%;
                height: 62%;

                .card-board-top {
                    position: fixed;
                    left: 14%;
                    top: 19.8%;
                    width: 72%;
                    height: 6.5%;
                    background: linear-gradient(0deg, #3993FF, #6DB4FF);
                    box-shadow: 0px 3px 3px 0px rgba(40, 42, 45, 0.21), 0px 4px 8px 0px rgba(255, 255, 255, 0.36);
                    border-radius: 10px;
                    font-weight: 400;
                    color: #FEFEFF;
                    line-height: 5px;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    font-size: 1.4rem;
                    letter-spacing: 2px;
                }

                .card-board-box {

                    .cbb-clipper {
                        height: 40px;
                        width: auto;
                    }

                    .cbb-card {
                        width: 7.5rem;
                        height: 8.2rem;   
                    }

                    .cbb-image {
                        width: 100px;
                        height: auto;
                    }

                    #image-1 {

                       .cbb-clipper {
                            position: fixed;
                            left: 24%;
                            top: 31%;
                            z-index: 100;
                       }

                        .cbb-card {
                            position: fixed;
                            left: 12.1%;
                            top: 34.7%;
                        }

                        .cbb-image {
                            position: fixed;
                            left: 14.4%;
                            top: 35.6%;
                        }
                    }

                    #image-2 {

                        .cbb-clipper {
                            position: fixed;
                            right: 26%;
                            top: 31.6%;
                            z-index: 100;
                        }

                        .cbb-card {
                            position: fixed;
                            right: 14%;
                            top: 35.4%;
                        }

                        .cbb-image {
                            position: fixed;
                            right: 16.4%;
                            top: 36.2%;
                        }
                    }

                    #image-3 {

                        .cbb-clipper {
                            position: fixed;
                            left: 15%;
                            top: 53.1%;
                            z-index: 100;
                        }

                        .cbb-card {
                            position: fixed;
                            left: 3.3%;
                            top: 57%;
                        }

                        .cbb-image {
                            position: fixed;
                            left: 5.8%;
                            top: 57.7%;
                        }
                    }

                    #image-4 {

                        .cbb-clipper {
                            position: fixed;
                            left: 47%;
                            top: 54.9%;
                            z-index: 100;
                        }

                        .cbb-card {
                            position: fixed;
                            left: 35%;
                            top: 58.8%;
                        }

                        .cbb-image {
                            position: fixed;
                            left: 37.5%;
                            top: 59.5%;
                        }
                    }

                    #image-5 {

                        .cbb-clipper {
                            position: fixed;
                            right: 16%;
                            top: 52.8%;
                            z-index: 100;
                        }

                        .cbb-card {
                            position: fixed;
                            right: 4%;
                            top: 56.5%;
                        }

                        .cbb-image {
                            position: fixed;
                            right: 6.5%;
                            top: 57.4%;
                        }
                    }
                }
            }

            #cb-line-1 {
                position: fixed;
                left: 0;
                top: 30%;
            }

            #cb-line-2 {
                position: fixed;
                left: 0;
                top: 53%;
            }
        }
    }
</style>